import { Auth } from 'aws-amplify';

export async function getJwtLink(fileUrl?: string | null) {
  const jwtToken = (await Auth.currentSession()).getIdToken().getJwtToken();
  return fileUrl ? `${fileUrl}?jwt=${jwtToken}` : null;
}
